import { render } from "./BreadCrumbs.vue?vue&type=template&id=f0b74e92&scoped=true&ts=true"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=f0b74e92&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b74e92"]])

export default __exports__